var SolutionThirdPartyProductWtuComponentController = (function () {
    function SolutionThirdPartyProductWtuComponentController() {
    }
    SolutionThirdPartyProductWtuComponentController.prototype.$onChanges = function () {
        this.contactSupportUrl = undefined;
        this.wtuItemLink = undefined;
        this.additionalDataToSend = undefined;
        if (this.group) {
            var _a = this.group, familyId = _a.familyId, familyName = _a.familyName, segmentType = _a.segmentType, sku = _a.sku, supportPageUrl = _a.supportPageUrl;
            this.contactSupportUrl = supportPageUrl + "/" + sku + "/contact-support";
            this.additionalDataToSend = { familyId: familyId, familyName: familyName, segmentType: segmentType };
        }
        if (this.thirdPartyProduct) {
            var _b = this.thirdPartyProduct, manufacturer = _b.manufacturer, name_1 = _b.name;
            this.wtuItemLink = "CG/Solutions/" + manufacturer + " " + name_1;
        }
    };
    SolutionThirdPartyProductWtuComponentController.$inject = [];
    return SolutionThirdPartyProductWtuComponentController;
}());
export var SolutionThirdPartyProductWtuComponent = {
    bindings: {
        group: '<',
        thirdPartyProduct: '<',
    },
    controller: SolutionThirdPartyProductWtuComponentController,
    template: "\n    <was-this-useful additional-data-to-send=\"::$ctrl.additionalDataToSend\"\n                     hash-in-share-url=\"false\" \n                     item-link=\"::$ctrl.wtuItemLink\"\n                     contact-support-url=\"::$ctrl.contactSupportUrl\">\n    </was-this-useful>\n  ",
};
